import React, { useEffect, useRef, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaMobileAlt,
  FaPinterest,
  FaTwitter,
  FaYoutube,
  FaPhoneAlt,
} from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import CommonForm from "../components/Form/CommonForm";
import { RiArrowRightLine } from "react-icons/ri";
import { FiPhone, FiMail } from "react-icons/fi";
import card1 from "../Assets/newAsset/clients/newClientsImages/card1.webp";
import logoWhite from "../Assets/newAsset/lpassets/clearFooter.svg";

import card2 from "../Assets/newAsset/clients/newClientsImages/card2.webp";
import card3 from "../Assets/newAsset/clients/newClientsImages/card3.webp";
import card4 from "../Assets/newAsset/clients/newClientsImages/card4.webp";
import SP from "../Assets/newAsset/clients/newClientsImages/ServicesProvided.webp";
import rightBanner from "../Assets/newAsset/clients/newClientsImages/Illustration.webp";
import BelwBan from "../Assets/newAsset/clients/belowBaner.webp";
import styled from "styled-components";
import PartnerBanner from "../Assets/newBanner.webp";
import { useDispatch, useSelector, connect } from "react-redux";
import { getCall, getCities } from "../Redux/Actions";
import { GET_CALL_RESET } from "..//Redux/Constants";
import { Scroll } from "../components/Scroll function/scroll";
import TopNav from "../components/TopNav/TopNav";
// import Header from "../components/Header/Header";
import NewHeader from "../components/NewHeader/NewHeader";
import ScrolltoTop from "../components/Scrolltotop/ScrolltoTop";
import Footer from "../components/Footer/Footer";
import SubFooter from "../components/SubFooter/SubFooter";
import "./corporate.css";
import { BrowserRouter as Router, Switch, useLocation } from "react-router-dom";
import Meta from "../components/Meta";
import { Modal } from "react-responsive-modal";
import PatientActions from "../components/Cart/PatientDetailsAction";
import LpForm from "./packageDetailsPage/LpForm";
import ImagingFooter from "../components/Redcliffe-Imaging/ImagingFooter";

//LPFOOTER
export const LpFooter = () => {
  return (
    <div className="footerLp">
      <div className="footerContainer">
        <div className="footerFirstRow">
          <div className="logoIMg">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/6666d24d-f9ef-44e3-8aa7-5230252a55c7.webp"
              alt={logoWhite}
            ></img>
          </div>
          <div className="footerDesc">
            <p>
              Redcliffe Labs is an accredited advanced diagnostic laboratory
              that aims at providing top-notch consistent and accurate
              laboratory services with modern technology and equipment all
              inclusive of logistics management.
            </p>
          </div>
        </div>
        <div className="footerSecondRow">
          <div className="footerLogo">
            <span>Contact Us</span>
            <a href="mailto:corporate@redcliffelabs.com">
              <div className="emailLogo">
                <span>
                  <FiMail />
                </span>
                corporate@redcliffelabs.com
              </div>
            </a>

            <a href="tel:+91998 055 3983">
              <div className="phoneLogo">
                <span>
                  <FiPhone />
                </span>
                998 055 3983
              </div>
            </a>
          </div>
        </div>
        <div className="borderDiv"></div>
        <div className="footerThirdRow">
          <div className="footerMsg">
            <p>
              Redcliffe Labs <br /> © 2022. All rights reserved.
            </p>
            <p>
              Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
              and prevention of Misuse) Act, 1994", our labs strictly does not
              determine the sex of the fetus.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
const Corporate = (props) => {
  const [open, setOpen] = useState(false);

  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);

  //GETTING DATA FROM STORE (CITIES NAME) STARTS HERE
  const navCity = useSelector((state) => state.navCityList);
  const { navCities } = navCity;
  const citiesFromArray = navCities;
  console.log("city name from store", citiesFromArray);
  //GETTING DATA FROM STORE (CITIES NAME) ENDS HERE

  const location = useLocation();

  var url = `https://redcliffelabs.com` + location.pathname;

  useEffect(() => {
    dispatch(getCities());
  }, []);

  const [name, setName] = useState("");
  const [tel, setTel] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [text, setText] = useState("");

  const [cityFocus, setCityFocus] = useState(false);

  const [message, setMessage] = useState("");

  const timer = useRef(0);

  const callRecieve = useSelector((state) => state.callRecieve);
  const { success } = callRecieve;

  const cityList = useSelector((state) => state.cityList);
  const { cities, loading } = cityList;

  const dispatch = useDispatch();

  const handleSubmit = (e) => {
    console.log("pressdel");
    e.preventDefault();
    const body = {
      name,
      phone_no: tel,
      source: "Ecommerce",
      email: `${email}`,
      city: `${company}`,
      message: `${text}`,
      url,
    };
    console.log(body.phone_no);
    if (body.phone_no.length < 10 || body.phone_no.length > 11) {
      console.log("please add correct no");
      setMessageTel("Enter 10 Digit Mobile Number");
    } else {
      dispatch(getCall(body));
      setMessageTel("");
      setMessageName("");
    }
  };

  useEffect(() => {
    if (success) {
      setName("");
      setTel("");
      setCompany("");
      setEmail("");
      setText("");
      setMessage("Your form has been submitted successfully!");
      setTimeout(() => {
        dispatch({
          type: GET_CALL_RESET,
        });
        setMessage("");
      }, 5000);
    }
  }, [success]);

  //    form validation
  const [buttonDisable, setButtonDisable] = useState(true);
  const [messageName, setMessageName] = useState("");
  const [messageTel, setMessageTel] = useState("");

  //validating email
  const [emailError, setEmailError] = useState("");

  const emailValidation = (e) => {
    setEmail(e.target.value);

    const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (e.target.value.match(regex)) {
      setEmailError("");
    } else {
      console.log("invalid email");
      setEmailError("invalid email");
    }
  };

  const [cityNameError, setCityNameError] = useState("");

  const handleCompanyName = (e) => {
    const characterRegex = /^([A-Za-z]+[ ]?)+$/;
    console.log(e.target.value.match(characterRegex), "company regxxxx");
    if (!e.target.value.match(characterRegex)) {
      setCityNameError("Enter Character only");
      // setButtonDisable(true);
      console.log("passed");
    }
    if (e.target.value != "" && e.target.value.match(characterRegex)) {
      setCityNameError("");
      // setButtonDisable(false);
    }
    if (e.target.value == "") {
      setCityNameError("");
      // setButtonDisable(true);
    }
    setCompany(e.target.value);
  };

  // validation testing

  const handleNameChange = (e) => {
    // const regex = /\d/;
    const regex = /^[a-zA-Z\s]+$/g;
    console.log(regex.test(e.target.value));

    if (regex.test(e.target.value)) {
      // console.log("value is true")

      setButtonDisable(true);
      // setValue("#"+validator.trim(e.target.value)+"#")
      setMessageName("Please Enter Character Only");
    } else if (!regex.test(e.target.value)) {
      // console.log("value ifs false")
      if (e.target.value !== "") {
        setButtonDisable(false);
        setMessageName("Enter Character only");
      } else {
        setMessageName("");
      }
    } else {
      setButtonDisable(false);
      setMessageName("");
    }

    setName(e.target.value);
  };
  const handleTelChange = (e) => {
    const whitespace = / /g;
    // const whitespace = /^((\+){1}91){1}[1-9]{1}[0-9]{9}$/;
    // const whitespace = ^[7-9][0-9]{9}$;

    console.log(e.target.value[0]);
    e.preventDefault();
    //  console.log(e.target.value)
    if (
      isNaN(e.target.value) ||
      whitespace.test(e.target.value) ||
      e.target.value.length > 11 ||
      e.target.value[0] == 1 ||
      e.target.value[0] == 2 ||
      e.target.value[0] == 3 ||
      e.target.value[0] == 4 ||
      e.target.value[0] == 5
    ) {
      //  if(whitespace.test(e.target.value))
      setButtonDisable(true);
      setMessageTel("Enter 10 Digit Mobile Number");
    } else if (e.target.value[0] == 0) {
      if (
        e.target.value[1] == 1 ||
        e.target.value[1] == 2 ||
        e.target.value[1] == 3 ||
        e.target.value[1] == 4 ||
        e.target.value[1] == 5 ||
        e.target.value.length !== 11
      ) {
        setButtonDisable(true);
        setMessageTel("Enter 11 Digit Mobile Number");
      } else {
        setButtonDisable(false);
        setMessageTel("");
      }
    } else if (e.target.value[0] == "+" || e.target.value[0] == "-") {
      setButtonDisable(true);
      setMessageTel("Enter Only Mobile Number");
    } else if (e.target.value[0] !== 0) {
      if (
        e.target.value[0] == 1 ||
        e.target.value[0] == 2 ||
        e.target.value[0] == 3 ||
        e.target.value[0] == 4 ||
        e.target.value[0] == 5 ||
        e.target.value.length !== 10
      ) {
        setButtonDisable(true);
        setMessageTel("Enter 10 Digit Mobile Number");
      } else {
        setButtonDisable(false);
        setMessageTel("");
      }
    } else if (!isNaN(e.target.value)) {
      setButtonDisable(false);
      setMessageTel("");
    }
    setTel(e.target.value);
  };

  useEffect(() => {
    Scroll();
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal?.token;
    if (token) {
      props?.getProfileDetails(token);
    }
  }, []);

  //calling city name api
  useEffect(() => {
    if (props?.userProfile?.phonenumber && props?.userProfile?.fullname) {
      setEmail(props?.userProfile?.email);
      setTel(props?.userProfile?.phonenumber);
      setName(props?.userProfile?.fullname);
    }
  }, [props?.userProfile]);

  return (
    <React.Fragment>
      <Meta
        title=" Corporate - Redcliffe Labs"
        description="If you are a phlebotomist / healthcare professional / aspirant entrepreneur, Redcliffe Labs is the right lab to start your entrepreneurial journey."
      ></Meta>
      {/* <TopNav
        isCorporate={true}
        phone="928 9070 234"
        email="corporate@redcliffelabs.com"
      /> */}
      <NewHeader phone="928 9070 234" />
      <div className="corporateImg corporateImg2">
        <div className="topSection">
          <div className="corporate_leftSide">
            <div className="coroHead">
              <span className="corporateHeadingBlue">LOOKING FOR </span>
              <h1 className="corporateHeadingPink">CORPORATE TIE - UP</h1>
              <img src={SP} alt={SP} className="spImg" />
            </div>

            <div className="corporate_cards">
              <div className="card_corporateMain " onClick={onOpenModal}>
                <img src={card1} alt={card1} />
                <span>Annual Health Checkup</span>
              </div>
              <div className="card_corporateMain pink" onClick={onOpenModal}>
                <img src={card2} alt={card2} />
                <span>Pre Employment Health Check up</span>
              </div>
              <div className="card_corporateMain" onClick={onOpenModal}>
                <img src={card3} alt={card3} />
                <span>Preventive Health Check Up Camps</span>
              </div>
              <div className="card_corporateMain pink" onClick={onOpenModal}>
                <img src={card4} alt={card4} />
                <span>
                  Privilege <br />
                  Discount
                </span>
              </div>
            </div>

            <div className="serving_section">
              <span className="servingText">Serving in more than </span>
              <span className="citiesServing">
                34 <br />
                cities
              </span>
            </div>

            <div className="bottomSection topSec  ">
              <span className="">For Corporate Enquiry</span>
              <span className="phoneInquiry">
                <a href="tel:+919980553983">
                  <FaPhoneAlt /> 998 055 3983
                </a>
              </span>
              <span className="emailINquiry">
                <a href="mailto:corporate@redcliffelabs.com">
                  <GrMail /> corporate@redcliffelabs.com
                </a>
              </span>
            </div>
          </div>
          <div className="corporate_rightSide">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-images/None/ffcfcc7c-b1db-48ff-849f-8f1db3b230a3.png"
              alt={rightBanner}
            />
            <div className="bottomSection bottomSec">
              <span className="">For Corporate Enquiry</span>
              <span className="phoneInquiry">
                <a href="tel:+91 998 055 3983">
                  <FaPhoneAlt /> 998 055 3983
                </a>
              </span>
              <span className="emailINquiry">
                <a href="mailto:corporate@redcliffelabs.com">
                  <GrMail /> corporate@redcliffelabs.com
                </a>
              </span>
            </div>
          </div>
        </div>

        {/* <div className="mobileHeading__corporate">
          <span>LOOKING FOR CORPORATE TIE - UP </span>
          <img src={SP} className="img_fluid"></img>
        </div> */}
        {/**COORPORATE DIVS FOR WEB */}
        {/* <div className="Corporate_content">
          <div className="Corporate_card" onClick={onOpenModal}>
            <img src={card1} alt="cards" />
            <span>Annual Health Checkup</span>
          </div>
          <div className="nextRow">
            <RiArrowRightLine />
          </div>
          <div className="Corporate_card" onClick={onOpenModal}>
            <img src={card3} alt="cards" />
            <span>Pre Employment Health Check up</span>
          </div>
          <div className="nextRow">
            <RiArrowRightLine />
          </div>

          <div className="Corporate_card" onClick={onOpenModal}>
            <img src={card4} alt="cards" />
            <span>Preventive Health Check Up Camps</span>
          </div>
          <div className="nextRow">
            <RiArrowRightLine />
          </div>
          <div className="Corporate_card" onClick={onOpenModal}>
            <img src={card2} alt="cards" />
            <span>
              Privilege <br />
              Discount
            </span>
          </div>
        </div> */}

        {/**COORPORATE DIVS FOR MOB */}

        {/* <div className="Corporate_contentMobile">
          <div className="corporateMobile_Card">
            <div className="Corporate_card" onClick={onOpenModal}>
              <img src={card1} alt="cards" />
              <span>Annual Health Checkup</span>
            </div>
         
            <div className="Corporate_card" onClick={onOpenModal}>
              <img src={card3} alt="cards" />
              <span>Pre Employment Health Check up</span>
            </div>
          </div>
          <div className="nextDivIcons">
            <div className="nextRow">
              <RiArrowRightLine />
            </div>
            <div className="nextRow">
              <RiArrowRightLine />
            </div>
          </div>
          <div className="corporateMobile_Card">
            <div className="Corporate_card" onClick={onOpenModal}>
              <img src={card4} alt="cards" />
              <span>Preventive Health Check Up Camps</span>
            </div>
         
            <div className="Corporate_card" onClick={onOpenModal}>
              <img src={card2} alt="cards" />
              <span>
                Privilege <br />
                Discount
              </span>
            </div>
          </div>
        </div> */}

        {/**Below Banner */}
        {/* <div className="coorporateBelow">
          <img src={BelwBan} className="img_fluid"></img>
        </div> */}
        {/* 
        <div className="emailPhone_Details">
          <span>For Corporate Enquiry</span>
          <span className="secondSpan">
            <a href="tel:+91998 055 3983">Call : 998 055 3983</a>
          </span>
          <span>
            <a href="mailto:corporate@redcliffelabs.com">
              Email : corporate@redcliffelabs.com
            </a>
          </span>
        </div> */}
        <Modal open={open} onClose={onCloseModal} center>
          <div className="formContainer modalForm">
            <h2>Get In Touch </h2>
            <form className="form container" onSubmit={handleSubmit}>
              <div className="col-xs-12 col-sm-6">
                <div className="inputContainer">
                  {/* <input value={name} type="text"  placeholder="Your Name*" onChange={(e) => setName(e.target.value)} /> */}
                  <input
                    type="text"
                    placeholder="Enter Name*"
                    onChange={handleNameChange}
                    value={name}
                    required
                  ></input>
                  <br />
                  <span
                    style={{
                      color: "red",
                      fontSize: "18px",
                      margin: "-11px 12px",
                      position: "absolute",
                    }}
                  >
                    {messageName}
                  </span>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className="inputContainer">
                  <input
                    value={email}
                    required
                    type="email"
                    placeholder="Your Email*"
                    onChange={emailValidation}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    fontSize: "18px",
                    margin: "-11px 12px",
                    position: "absolute",
                  }}
                >
                  {emailError}
                </span>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div className="inputContainer">
                  {/* <input value={tel} required type="tel" placeholder="Enter Phone*" onChange={(e) => setTel(e.target.value)} /> */}
                  <input
                    type="tel"
                    required
                    placeholder="Enter Phone*"
                    onChange={handleTelChange}
                    value={tel}
                  ></input>
                  <br />
                  <span
                    style={{
                      color: "red",
                      margin: "-11px 12px",
                      position: "absolute",
                      fontSize: "18px",
                    }}
                  >
                    {messageTel}
                  </span>
                </div>
              </div>
              <div className="col-xs-12 col-sm-6">
                <div
                  className="inputContainer"
                  style={{ position: "relative" }}
                >
                  <input
                    value={company}
                    required
                    type="text"
                    placeholder="Company Name*"
                    onChange={handleCompanyName}
                  />
                </div>
                <span
                  style={{
                    color: "red",
                    fontSize: "18px",
                    margin: "-11px 12px",
                    position: "absolute",
                  }}
                >
                  {cityNameError}
                </span>
              </div>
              <div className="col-xs-12">
                <div className="inputContainer">
                  <textarea
                    name="message"
                    id="message"
                    rows="10"
                    required
                    placeholder="Remarks*"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="successDiv">
                {" "}
                {success && (
                  <p style={{ color: "green", fontSize: "18px" }}>{message}</p>
                )}
              </div>
              <button
                disabled={
                  messageTel !== "" ||
                  messageName !== "" ||
                  cityNameError !== "" ||
                  emailError !== ""
                    ? true
                    : false
                }
                type="submit"
                className="btn-primary"
                style={{ margin: "auto" }}
              >
                Submit
              </button>
            </form>
          </div>
        </Modal>
      </div>
      {/* <img
        src={PartnerBanner}
        alt="partnerBanner"
        className="banner"
        style={{ width: "100%" }}
      /> */}
      <div className="PartnerWrapper corporate">
        {/* <div className="section">
          <h4 className="head">CORPORATE </h4>
        </div> */}
        <div
          className="container contentContainer"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <div className="content">
            {/* <h2 className="titleTop">
              If you are a Phlebotomist / Healthcare Professional / Aspirant
              Entrepreneur Redcliffe Labs is the right lab to start
              your entrepreneurial Journey
            </h2>
            <p>
              If you have any questions or queries, our customer support team is
              always there to assist you. Feel free to contact us and we will
              get back to you as soon as possible.
            </p> */}
          </div>
        </div>
        <div className="formContainer"></div>
        <div className="container contentContainer">
          <div className="content">
            <h2 className="title" style={{ textAlign: "center" }}>
              Please get in touch and our expert support team will answer your
              questions.
            </h2>
            <p style={{ textAlign: "center", fontSize: "15px" }}>
              Please do not hesitate to get in touch with your inquiry, your
              feedback, or with any comments you might have.
            </p>
            <p
              style={{
                textAlign: "center",
                marginBottom: "0.5rem",
                fontWeight: "700",
                // color: "black !important",
                fontSize: "15px",
              }}
            >
              Call us for instant assistance to this number
            </p>
            <h2 style={{ textAlign: "center" }}>
              <a
                href="tel:+91998 055 3983"
                className="title"
                style={{ color: "#0a406b", marginBottom: "1rem" }}
              >
                998 055 3983
              </a>
            </h2>
            <p
              style={{
                textAlign: "center",
                marginBottom: "0.5rem",
                fontWeight: "700",
                // color: "black !important",
                fontSize: "15px",
              }}
            >
              Or Email us with any questions or inquiries
            </p>
            <h2 style={{ textAlign: "center" }}>
              <a
                href="mailto:corporate@redcliffelabs.com"
                className="title"
                style={{
                  color: "#0a406b",
                  marginBottom: "1rem",
                  cursor: "pointer",
                  textTransform: "initial",
                }}
              >
                corporate@redcliffelabs.com
              </a>
            </h2>
            <div className="social-icons" style={{ marginTop: "1rem" }}>
              <div>
                <a
                  className="color"
                  target="_blank"
                  href="https://twitter.com/redcliffelab"
                >
                  <FaTwitter fontSize="1.3rem" />
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  className="color"
                  href="https://www.facebook.com/RedcliffeLabs/"
                >
                  <FaFacebook fontSize="1.3rem" />
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  className="color"
                  href="https://www.linkedin.com/company/redcliffe-labs/"
                >
                  <FaLinkedin fontSize="1.3rem" />
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  className="color"
                  href="https://www.instagram.com/redcliffelabs/"
                >
                  <FaInstagram fontSize="1.3rem" />
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  className="color"
                  href="https://in.pinterest.com/Redcliffe_Labs"
                >
                  <FaPinterest fontSize="1.3rem" />
                </a>
              </div>
              <div>
                <a
                  target="_blank"
                  className="color"
                  href="https://www.youtube.com/c/RedcliffeLabs"
                >
                  <FaYoutube fontSize="1.3rem" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrolltoTop />
      {/* <ImagingFooter email={'corporate@redcliffelabs.com'} telNumber={'965 4389 448'}/> */}

      <div className="footerLp">
        <div className="footerContainer">
          <div className="footerFirstRow">
            <div className="logoIMg">
              <img
                src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/52f0edfe-5ef0-4bec-a319-8c1eee0564f6.svg"
                alt={logoWhite}
              ></img>
            </div>
            <div className="footerDesc">
              <p>
                Redcliffe Labs is an accredited advanced diagnostic laboratory
                that aims at providing top-notch consistent and accurate
                laboratory services with modern technology and equipment all
                inclusive of logistics management.
              </p>
            </div>
          </div>
          <div className="footerSecondRow">
            <div className="footerLogo">
              <span>Contact Us</span>
              <a href="mailto:corporate@redcliffelabs.com">
                <div className="emailLogo">
                  <span>
                    <FiMail />
                  </span>
                  corporate@redcliffelabs.com
                </div>
              </a>

              <a href="tel:+91998 055 3983">
                <div className="phoneLogo">
                  <span>
                    <FiPhone />
                  </span>
                  998 055 3983
                </div>
              </a>
            </div>
          </div>
          <div className="borderDiv"></div>
          <div className="footerThirdRow">
            <div className="footerMsg">
              <p>
                Redcliffe Labs <br /> © 2022. All rights reserved.
              </p>
              <p>
                Disclaimer: As per "Pre-Natal Diagnostic Techniques (Regulation
                and prevention of Misuse) Act, 1994", our labs strictly does not
                determine the sex of the fetus.
              </p>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state?.Profile?.profileDate,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getProfileDetails: (token) => {
      dispatch(PatientActions.getProfileDetails(token));
    },
  };
};

export default {
  component: connect(
    mapStateToProps,
    mapDispatchToProps
  )(React.memo(Corporate)),
};
